import { connect } from 'react-redux';
import Success from './success.component';
import { State } from 'widgets/redeem/root/root.reducers';
import { ISuccessStateProps } from './success.types';

const mapStateToProps = (state: State): ISuccessStateProps => ({
    contentGameItem: state.PYCRedeemReducer.contentGameItems.find(
        item => (item.actionIds || []).includes(state.PYCRedeemReducer.selectedGameItemId)
    )!,
});

export const SuccessContainer = connect(
    mapStateToProps
)(Success);

export default SuccessContainer;
